import { useCallback } from 'react';

import { useSelfServiceAccount } from '@eneco/auth-be-self-service';
import { useSetNotification } from '@eneco/components-next/Notification/Notification';
import { useRouter } from '@eneco/next';
import { NotificationBoxProps } from '@eneco/sparky/types';

type NotificationContent = Omit<NotificationBoxProps, 'isAlert' | 'isElevated'>;

/**
 * @returns wrapper function for the useRedirectAndNotify hook to accommodate the locale
 * before the route (if not present), adding a trailing slash (if not present) and removes
 * query params
 */
export const useRedirectAndNotifyBE = () => {
  const { pushHref, locale } = useRouter();
  const setNotification = useSetNotification();

  return useCallback(
    (notification: NotificationContent & { route: string }) => {
      let notificationRoute = notification.route;

      if (!notificationRoute.includes(locale)) {
        notificationRoute = '/' + locale + notificationRoute;
      }
      // notification.route is checked with activePath, which does not include the query params, so it would fail if included
      notification.route = notificationRoute;
      if (notification.route.includes('?')) {
        notification.route = notification.route.split('?')[0];
      }
      setNotification(notification);
      pushHref(notificationRoute);
    },
    [setNotification, pushHref, locale],
  );
};

export const useSwitchAccountAndRedirectAndNotifyBE = () => {
  const { switchAccount } = useSelfServiceAccount();
  const redirectAndNotify = useRedirectAndNotifyBE();

  return useCallback(
    (props: NotificationContent & { route: string; crmAccountNumber: string }) => {
      const { crmAccountNumber, ...notification } = props;
      switchAccount({ crmAccountNumber });
      redirectAndNotify(notification);
    },
    [switchAccount, redirectAndNotify],
  );
};
